import styled from 'styled-components';

export const ServiceTypeContainer = styled.div`
  display: flex;
  font-family: 'Roboto', sans-serif;
  justify-content: space-between;
  align-items: stretch;
  gap: 8px;
  margin-top: 10px;
  /* Fixed width so four package cards (incl. No Standard Package) share equal size. */
  width: 760px;

  > div {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
  }
`;

export const ServiceTypeDescription = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
`;

export const AdvancedContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: 'Roboto', sans-serif;
  justify-content: space-between;
  gap: 5px;
`;

export const PersonCount = styled.div<{ isOverLimit: boolean }>`
  font-size: 14px;
  font-weight: bold;
  /* Highlight over-allocation immediately so users can rebalance package participants. */
  color: ${props => props.isOverLimit ? 'red' : 'inherit'};
  text-align: center;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const AddonButton = styled.button<{ isSelected: boolean }>`
  color: ${props => props.isSelected ? '#1AB683' : '#AC2A6E'};
  border: ${props => props.isSelected ? '#1AB683 2px solid' : '#AC2A6E 2px solid'};
  border-radius: 20px;
  background: transparent;
  font-weight: bold;
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  cursor: pointer;
`;

export const AddonContainer = styled.div`
  background: white;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  font-size: 15px;
  line-height: 1.5;
`;

export const PrevDayDinnerContainer = styled.div`
  display: flex;
  font-size: 14px;
  line-height: 1.5;
  justify-content: space-between;
`;

export const IconContainer = styled.div`
  width: 25px;
`;

export const DinnerInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const PersonCountContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
